<template>
  <div class="ma-4">
    <SkeletonLoaderTitleUpdate v-show="showSkeleton" />
    <div class="text-h4 mb-2 ml-4" v-show="!showSkeleton">Atualizar Departamento - {{ description }}</div>

    <div v-if="canRender">
      <CadastroDepartamento edicao="true" :_id="_id" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import { registerVuexModule } from '@/utils/vuexUtils'
import SkeletonLoaderTitleUpdate from '@/componentes/SkeletonLoaderTitleUpdate'

import departamentoStore from '../_store'

import CadastroDepartamento from './CadastroDepartamento'

export default {
  props: {
    _id: String,
  },

  components: { CadastroDepartamento, SkeletonLoaderTitleUpdate },

  data: () => ({
    description: '',
    showSkeleton: false,
    canRender: false,
  }),

  computed: {
    ...mapGetters('atualizarDepartamentoModuleCallCenterStore', ['getDepartamentoEspecifico']),
  },

  async created() {
    this.showSkeleton = true

    registerVuexModule(this.$store, 'atualizarDepartamentoModuleCallCenterStore', departamentoStore)
    await this.listarDepartamentoEspecifico(this._id)
    this.description = this.getDepartamentoEspecifico.description

    this.showSkeleton = false
    this.canRender = true
  },

  methods: {
    ...mapActions('atualizarDepartamentoModuleCallCenterStore', ['listarDepartamentoEspecifico']),
  },
}
</script>
